import { InputFieldV5, TextareaV5 } from "components/form";

const INPUT_FIELDS = [
  {
    name: "date",
    group: "common",
    type: "date",
    icon: "far fa-calendar-alt",
    className: "input ",
    component: InputFieldV5,
    required: true,
    userCanEdit: true,
  },
  {
    name: "progesteroneLevel",
    group: "heatDiary",
    type: "number",
    icon: "fas fa-ruler-vertical",
    className: "input ",
    component: InputFieldV5,
    required: true,
    userCanEdit: true,
  },
  {
    name: "progNotes",
    group: "heatDiary",
    type: "text",
    className: "textarea",
    component: TextareaV5,
    rows: 5,
    required: false,
    charLimit: 500,
    userCanEdit: true,
  },
];

export { INPUT_FIELDS };
